import { useContextError } from "common-frontend-components";
import { CommentContext } from "./CommentContext";

export default function useComment() {
    return useContextError(CommentContext.name, CommentContext);
}
